import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, formatDateTime} from '../Univ.js'
function IpBillList() {
    const [ipViewData, setIpViewData] = useState([]);
    useEffect(() => {
        fetchIpViewData();
    }, []);
    function fetchIpViewData() {
        const url = `${baseUrl}view-ip/?status=2`;
        axios.get(url)
            .then(response => {
                setIpViewData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'provisional', headerName: 'Prov',
            renderCell: (params) => (
                <Link to={`/bill-provisional/${params.row.id}/`} className="btn btn-info">
                    Prov
                </Link>
            ),
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'summary',
            headerName: 'Sumry',
            renderCell: (params) => (
                <Link to={`/bill-summary/${params.row.id}/`} className="btn btn-warning">
                    Sumry
                </Link>
            ),
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'insurance',
            headerName: 'Insur',
            renderCell: (params) => {
                const {id, payment} = params.row;
                if (payment == 'Insurance') {
                    return (
                        <>
                            <Link to={`/bill-insurance/${params.row.id}/`} className="btn btn-danger">
                                Insur
                            </Link>
                        </>
                    );
                }
            },
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {field: 'ip_id', headerName: 'IP ID', width: 100},
        {field: 'pat__pat_id', headerName: 'Pat Id', width: 80},
        {field: 'pat__patient', headerName: 'Patient', width: 150},
        {field: 'pat__mobile', headerName: 'Mobile', width: 100},
        {field: 'pat__address1', headerName: 'Address', width: 220},
        {field: 'primary_consult__consultant', headerName: 'Consultant', width: 100},
        {field: 'room_no__room_no', headerName: 'Room No', width: 75},
        {field: 'payment', headerName: 'Payment', width: 100},
        {
            field: 'admit_date', headerName: 'Admitted On', width: 150,
            renderCell: (params) => (
                <span>{formatDateTime(params.value)}</span>
            ),
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    IP Billing Summary List
                </h3>
                {ipViewData.length > 0 ? (
                    <div style={{height: "100%", width: "100%"}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={ipViewData}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar,}}
                            autoHeight
                            initialState={{
                                sorting: {
                                    sortModel: [{field: 'admit_date', sort: 'desc'}],
                                },
                            }}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section>
    )
}
export default IpBillList;
